var Flight = {
		hasReturnDate:false,
		canDoLastHourRes:false,
		initialDepartureDate:null,
		initialReturnDate:null,
		numAdult:0,
		numChild:0,
		numInfant:0,
		hasResult:false,
		hasDepartures:false,
		hasReturns:false,
		isHistoryBack:false,
		source:null,
		landingDetailId:null,
		ignoreExtraPassengerSelection:false,
		multiProviderEnabled:false,
		result:false,
		defaultRoundtripSearch:false,
		direction:0
	};

$.ui.autocomplete.prototype._renderItem = function( ul, item){
	
	if (item.atype == 2) {

		ultext = "<a class='atype"+item.atype+"' >" + item.value + "</a>"; 
	    
	   $( "<li></li>" ).data( "ui-autocomplete-item", item ).append( ultext).appendTo( ul );
	    
	    if (item.airports != undefined && item.airports != null){
		    for(var i=0; i < item.airports.length;i++) {
		    	var airport = item.airports[i];
		    	
		    	ultext ="<a class='atype1'>" + airport.Name + " " +airport.Code + "</a></li>" ;
		    	
		    	$( "<li></li>" ).data( "ui-autocomplete-item", airport ).append( ultext).appendTo( ul );
		    }
	    }
	    return $( "<li></li>" );
	} else {
		// normal airport 
		ultext =  "<a class='' >" + item.value + "</a>" ;
		return $( "<li></li>" ).data( "ui-autocomplete-item", item ).append( ultext).appendTo( ul );
	}
};


$(document).ready(function(){
	
	if (window.location.pathname == '/startReservation' && $.cookie){
		$.cookie('source', null,{ path : '/' });
	}
	
	$("#fromAirport").on('input', function(e){	
		$('[name="fromAirportId"]').val('');
	});
	$("#toAirport").on('input', function(e){	
		$('[name="toAirportId"]').val('');
	});
	
	$("[name='direction']").change(function() {
		var value = $(this).val();
		if (value == "1") {
			Flight.direction=1;
			$(".returnDate").attr("disabled", "disabled");
		} else {
			Flight.direction=2;
			$(".returnDate").removeAttr("disabled");
		}
	}).click();

	$("#clrReturnDate").click(function() {
		$(this).hide();
		$("[name='direction'][value='1']").click();
		$(".returnDate").attr("disabled", "disabled");
		$(".return-date-text").show();
	});
	
	$(".summary #collapseReturnDateBox").click(function() {
		$("#clrReturnDate").show();
		$(".return-date-text").hide();
		$("[name='direction'][value='2']").click();
		$(".returnDate").removeAttr("disabled");
		$("#returnDate").datepicker("show");
	});
	
	$("#dateToDiv > div").on("click", function() {
		$("[name='direction'][value='2']").click();
		$(".returnDate").removeAttr("disabled");
		$("#returnDate").datepicker("show");
		$("#clrReturnDate").show();
		$(".return-date-text").hide();
	});

	var now = new Date();
	var aYearLater = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
	$(".departureDate").datepicker({ //Sadece ilk date pickerlar update oluyor, ilklerinden degerler alınarak set ediliyor.
		dateFormat : datePickerDateFormatDD,
		dayNames : DateLongNames.day,
		numberOfMonths : 1,
		showButtonPanel: true,
        closeText: "x",
		minDate : new Date(),
		maxDate : aYearLater,
		onSelect : function(dateText, inst) {
			
			var minDate = $.datepicker.parseDate(datePickerDateFormat, dateText.substr(0,10));
			var endDateStr = $("#returnDate").val();
			var endDate = null;
			if (endDateStr != "")
				endDate = $.datepicker.parseDate(datePickerDateFormat, endDateStr.substr(0,10));
			minDate.setDate(minDate.getDate());
			$(".returnDate").datepicker("option", "minDate", minDate);
			setDateValueToCookie('returnDateFlight', $("#returnDate").val());
			if (endDateStr == "" || minDate.getTime() >= endDate.getTime()) {
				var newEndDate = new Date(minDate);
				newEndDate.setDate(newEndDate.getDate() + 6);
				$(".returnDate").datepicker("setDate", newEndDate);
				setDateValueToCookie('returnDateFlight', $("#returnDate").val());
			}
			setDateValueToCookie('departureDateFlight', dateText);
		},

		onClose : function(dateText, inst) {
			var value = $("#departureDate").val(); // Birden fazla datepicker icin onemli !!!!
			$(".departureDate").val(value);
			if (2 == $('input[name=direction]:checked').val()) {
    			setTimeout(function() {
                    var context = inst.input.parent().parent();
					$('#returnDate',context).blur();
					$("#returnDate",context).datepicker("show");
                }, 100);
			}
			
		},
		beforeShow: function (elem, dp) {
			setTimeout(function(){ getSearchMinPriceData(dp);}, 50);
        },
        onChangeMonthYear: function (year, month, dp) {
            setTimeout(function(){getSearchMinPriceData(dp);}, 50);
        },
	});

    datepickerGoToToday();

	var minDate = null;
	var minDateStr = $("#departureDate").val();
	minDateStr == "" ? minDate = new Date() : minDate = $.datepicker.parseDate(datePickerDateFormat, minDateStr.substr(0,10));
	minDate.setDate(minDate.getDate());
	var maxDate = new Date();
	maxDate.setFullYear(minDate.getFullYear() + 1);
	$(".returnDate").datepicker({
		dateFormat : datePickerDateFormatDD,
		dayNames : DateLongNames.day,
		numberOfMonths : 1,
		minDate : minDate,
		maxDate : maxDate,
		showButtonPanel: true,
        closeText: "x",
		onClose : function(dateText, inst) {
			var value = $("#returnDate").val(); // Birden fazla datepicker icin onemli !!!!
			$(".returnDate").val(value);
			setDateValueToCookie('returnDateFlight', value );
		},

        beforeShow: function (elem, dp) {
            setTimeout(getSearchMinPriceData(dp), 100);
        },

        onChangeMonthYear: function (year, month, dp) {
            setTimeout(getSearchMinPriceData(dp), 100);
        },
        
	});

	$(".departureDate").keypress(function(event) {
		var currentDate = $(this).val();
		try {
			var d = $.datepicker.parseDate(datePickerDateFormat, currentDate.substr(0,10));
			d.setDate(d.getDate() + 6);
			$(".returnDate").datepicker("setDate", d);
			setDateValueToCookie('departureDateFlight', currentDate);
			setDateValueToCookie('returnDateFlight', $("#returnDate").val());
		} catch (e) {
		}
	});
	$(".departureDate").datepicker("setDate", Flight.initialDepartureDate);
	$(".returnDate").datepicker("setDate", Flight.initialReturnDate);					
	setDateValueToCookie('departureDateFlight', $("#departureDate").val());
	setDateValueToCookie('returnDateFlight', $("#returnDate").val());
	
	
	$(".airportAutoComplete").autocomplete({
		source : function(request, response) {
			$.ajax({
				url : "/airports",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term
				},
				success : function(data) {

					if ($("#divCityBoxDep").length)
						$("#divCityBoxDep").hide();

					if ($("#divCityBoxRet").length)
						$("#divCityBoxRet").hide();

					response($.map(data.ResultSet.Result.slice(0,10), function(item) {
						return {
							value :  item.CityName + ", " + item.Name + " (" + item.Code + "), " + item.CountryCode,
							id : item.id,
							atype: item.type,
							name : item.Name,
							cityName: item.CityName,
							countryName: item.CountryName,
							countryCode : item.CountryCode,
							airports : item.airports,
							city : item.CityCode
						};
					}));
				}
			});
		},
		select : function(event, ui) {
			document.activeElement.blur();
			$('[name="' + $(this).attr('name') + 'Id"]', this.form).val(ui.item.id);
			if (ui.item.city) {
			  $('[name="' + $(this).attr('name') + 'City"]', this.form).val(ui.item.city);
			}else if (ui.item.CityCode) {
			  $('[name="' + $(this).attr('name') + 'City"]', this.form).val(ui.item.CityCode);
			}
			$(this).data('autoCompleteId', ui.item.id);
			var item = Object.assign({}, ui.item);
            delete item['airports'];
			$.cookie($(this).attr('name'), JSON.stringify(item), { expires : 365, path : '/' });

		},
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    },
		minLength : 3
	}).change(function(event) {
		var itemId = $('[name="' + $(this).attr('name') + 'Id"]').val();
		var itemCity = $('[name="' + $(this).attr('name') + 'City"]').val();

		var item = {value: this.value, id: itemId, city:itemCity};
		$.cookie($(this).attr('name'), JSON.stringify(item), { expires : 365, path : '/' });
	});
	
	$(".airportAutoComplete").click(function() {
		$(this).select();
	});
	$(".setSelection").click(function() {
		$(this).focus();
		$(this).get(0).setSelectionRange(0,$(this).val().length);
	});
	
	// Start - Location set from Cookie
	if(!$('#fromAirport').val()){
		var itemJson = $.cookie('fromAirport', { path : '/' });
		if(itemJson){
			var item = JSON.parse(itemJson);

			if ('airports' in item){
				delete item['airports']
				var newItem = Object.assign({}, item);
                $.cookie('fromAirport', JSON.stringify(newItem), { expires : 365, path : '/' });
            }

			$('#fromAirport').val(item.value);
			$('[name="fromAirportId"]').val(item.id);
			if (item.city) {
				$('[name="fromAirportCity"]').val(item.city);
			}else if (item.CityCode) {
				$('[name="fromAirportCity"]').val(item.CityCode);
			}
		}
	}
	if(!$('#toAirport').val()){
		var itemJson = $.cookie('toAirport', { path : '/' });
		if(itemJson){
			var item = JSON.parse(itemJson);

            if ('airports' in item){
                delete item['airports']
                var newItem = Object.assign({}, item);
                $.cookie('toAirport', JSON.stringify(newItem), { expires : 365, path : '/' });
            }

			$('#toAirport').val(item.value);
			$('[name="toAirportId"]').val(item.id);
			if (item.city) {
				$('[name="toAirportCity"]').val(item.city);
			}else if (item.CityCode) {
				$('[name="toAirportCity"]').val(item.CityCode);
			}
		}
	}
	// End - Location set from Cookie
	
	
	// mobilde filter bar footer ı kapatmasın 
	$("#footer").addClass("has-filter-bar");
	
	 var locale = $.cookie('siteLocale');
	 $.smartbanner({
		    appStoreLanguage: locale, // Language code for App Store
		    iconGloss: false, // Force gloss effect for iOS even for precomposed (true or false)
		    button: FmtMessage.getMessage('js.button.title.playstoreView') // Text on the install button
		})
		$('.sb-close').on('click',function(){
			$("#smartbanner").hide();
		});


	$( ".spinnerTravelerADT" ).spinner({
		min: 0,
		max: 6
	});
	$( ".spinnerTravelerCHD" ).spinner({
		min: 0,
		max: 4
	});
	$( ".spinnerTravelerINF" ).spinner({
		min: 0,
		max: 3
	});
	
	$(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").change(function(){
		  
		var paxADT = $( "[name=paxADT]" ).spinner( "value" );
		  var paxCHD = $( "[name=paxCHD]" ).spinner( "value" );
		  var paxINF = $( "[name=paxINF]" ).spinner( "value" );
		  
		  try {
			$.cookie('numAdultFlight', paxADT, { expires : 365, path : '/' });
			$.cookie('numChildFlight', paxCHD, { expires : 365, path : '/' });
		   	$.cookie('numInfantFlight', paxINF, { expires : 365, path : '/' });
		  } catch (e) {
		  }
		  
		  var totalPax = parseInt(paxADT) + parseInt(paxCHD) + parseInt(paxINF);
		  $(".travelerSelectPax").html(totalPax);
		  var locale = $.cookie('siteLocale');
		  if(locale == "en"){
			  if(totalPax > 1){
			  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.travelers'));
			  }else{
			  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
			  }
		  }else if(locale == "ru" || locale == "uk"){
			  var partLast2 = totalPax % 100;
			  var partLast1 = totalPax % 10;
			  if(partLast1 == 0 || (partLast1 >= 5 && partLast1 <= 9) || (partLast2 >= 11 && partLast2 <= 14)){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru3'));
			  }else if(partLast1 == 1){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru1'));
			  }else if(partLast1 >= 2 && partLast1 <= 4){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru2'));
			  }
		  }else{
			  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
		  }
	});
	
	$(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").on("spinstop",function(){
		$(this).change();
	});
	
	if(Flight.numAdult){
		$('#paxADT').val(Flight.numAdult);
		$('#paxCHD').val(Flight.numChild);
		$('#paxINF').val(Flight.numInfant);
	} else if($.cookie('numAdultFlight')){
		$('#paxADT').val($.cookie('numAdultFlight'));
		$('#paxCHD').val($.cookie('numChildFlight'));
		$('#paxINF').val($.cookie('numInfantFlight'));		
	} else {		
		$('#paxADT').val("1");
		$('#paxCHD').val("0");
		$('#paxINF').val("0");
	}
	
	$(".spinnerTravelerADT").change();
	$(".spinnerTravelerCHD").change();
	$(".spinnerTravelerINF").change(); 
	
	$(".travelerSelect").click(function() {
		$('.travelerList').toggle("fade","fast");
		$('.mob-modal').show();
		return false;
	});
	$('body,.classSelect').click(function(event) {
		if (!$(event.target).closest('.travelerList').length) {
			$('.travelerList').hide();
		};
	});	
	$(".classSelect").click(function() {
		$('.classList').toggle("fade","fast");
		$('.mob-modal').show();
		return false;
	});
	$('body,.travelerSelect').click(function(event) {
		if (!$(event.target).closest('.classList').length) {
			$('.classList').hide();
		};
	});	
	$(".pop-close-btn").click(function() {
		// TODO: değişiklikleri temizleyip kapatmalı
		$('.classList, .travelerList,.mob-modal').hide();
		return false;
	});
	$(".pop-btn-ok").click(function() {
		$('.classList, .travelerList,.mob-modal').hide();
		return false;
	});
	
	$( "#radioDirections, #fclass" ).buttonset();

	$("[name=fclass]").change(function(){
		var id = this.id;
		var $label = $("[for=" + id + "]");
		$(".classSelect").html($label.find("span").html());
		$('.classList,.mob-modal').hide();
	});
	
	$('#link-table tr, #link-table-multi-prov-dep tr, #link-table-multi-prov-ret tr').hover(function(){
		$(this).addClass('f-hover');
		
		},function(){
			    $(this).removeClass('f-hover');
			});
	
	$(".d3toggle").click(function() {
		$('.result-graph').fadeToggle('fast');
		$(this).toggleClass('arrow');
	});
	
	$( "#matrix-tabs" ).tabs();
	$( ".filter-tabs" ).tabs();
	
	$( "#searchSorting" ).buttonset();

	$("[name=sortingSearch]").change(function(){
		var id = this.id;
		var $label = $("[for=" + id + "]");
		$(".btn-sort").html($label.find("span").html());
	});
	$(".btn-sort").click(function() {
		$('.pop-sorting').fadeToggle("fast");
		$(this).toggleClass("openFilter");
		return false;
	});
	
	$("#showFilter").click(function() {
		$('.resultLeft').fadeToggle("fast");
		$('.resultLeft').toggleClass("openFilter");
		$(this).toggleClass("openFilter");
		return false;
	});
	$(".pop-btn-ok").click(function() {
		$('.resultLeft,.pop-sorting').hide();
		$('.resultLeft').toggleClass("openFilter");
		return false;
	});

	$(document).click(function(event) { 
	    if(!$(event.target).closest('.pop-sorting').length) {
	        if($('.pop-sorting').is(":visible")) {
	            $('.pop-sorting').hide();
	        }
	    }        
	});

	
	if(Flight.result){
		if(Flight.hasDepartures){
			flightOpen["departure"] = true;
		}
		if(Flight.hasReturns){
			flightOpen["return"] = true;
		}
	}
	
	if(Flight.isHistoryBack){
		   setTimeout(function () {
			   window.history.back();
		    }, 3000);
	}
	
	$( "#MainAdDialog" ).dialog({
		autoOpen: false,
		width : 500,
		height : 600,
		modal : true,
		resizable : false,
		draggable : false, 
		show: {
			effect: "fade",
			duration: 400
			},
			hide: {
			effect: "fade",
			duration: 400
			}
	});
	$( ".mainAdDialogLink" ).click(function() {
		$( "#MainAdDialog" ).dialog( "open" );
	});
	
	if (Flight.multiProviderEnabled) {
		$(".multiprovider_block").hide();
		$(".mp-show-inline").addClass("active");
		$(".mp-show-block").removeClass("active");
	} else {
		$(".multiprovider_inline").hide();
		$(".mp-show-block").addClass("active");
		$(".mp-show-inline").removeClass("active");
	}

	$('.mp-show-block').click(function() {
		$(".multiprovider_inline").hide();
		$(".multiprovider_block").show();
		$(".mp-show-block").addClass("active");
		$(".mp-show-inline").removeClass("active");
	});
	$('.mp-show-inline').click(function() {
		$(".multiprovider_inline").show();
		$(".multiprovider_block").hide();
		$(".mp-show-inline").addClass("active");
		$(".mp-show-block").removeClass("active");
	});
	
	$( '.titleTip' ).tipTip();
	$( '.sr-brand-desc' ).tipTip();
	
	$( ".warningDialog" ).dialog({
    	resizable: false,
        height:240,
        width:400,
        modal: true,
        buttons:
            [
              {
                  text: FmtMessage.getMessage('js.search.no.result'),
                  click: function() {
                	  $( this ).dialog( "close" );
                  }
              }
            ]
    });
   
    $(".ui-dialog-titlebar").hide();
    $(".ui-dialog").css({'border-radius': '10px'});
    $(".ui-dialog-buttonpane").css({'background': '#eee'});
    
    
	if(Flight.source){
		var date = new Date();
		date.setTime(date.getTime() + (30 * 60 * 1000)); //30 minutes
		$.cookie('source', Flight.source, { expires : date,  path : '/' });
	}
	if(Flight.landingDetailId){
		$.cookie('landingDetailId', Flight.landingDetailId, { path : '/' });
	}
	
});

function setDateValueToCookie(name, value) {
	try {
		$.cookie(name, value.substr(0,10), { expires : 365, path : '/' });
	} catch (e) {
	}
}

function datepickerGoToToday(){

    var o_gotoToday = $.datepicker._gotoToday;

    $.datepicker._gotoToday = function(id) {

        o_gotoToday.call(this, id);
        var date = new Date();
        var selDate  = this.formatDate("dd.mm.yy", date);
        this._selectDate(id, selDate);

    }
}